import { createFileRoute } from '@tanstack/react-router';

import { CategorySectionModal } from '../../../../-components/SectionModal/CategorySectionModal';

export const Route = createFileRoute(
    '/_authenticated/placement/$tenantId/category/$categoryId/sections/new',
)({
    component: CategorySectionModal,
});
